import { useState } from "react"
import { useSearchParams } from "react-router-dom"
import RequireRole from "../../common/validation/require-role"
import { ALLOWED_ROLES_BY_ROUTE } from "../../common/constants/navbar"
import { selectUserDetails } from "../../redux/slices/auth"
import { useAppSelector } from "../../common/hooks"
import { useIsSuperAdmin } from "../../common/hooks/use-user-roles"
import PageHeader from "../../common/ui/page-header"
import PillTabs from "../../common/ui/pill-tabs"
import ApiKeysSection from "./api-keys-section"
import ApiUsageSection from "./api-usage-section"
import { ApiMarketingContent } from "./api-marketing-content"

const tabs = [
  { id: "keys", label: "Keys" },
  { id: "usage", label: "Usage" }
]

const ApiPage = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [currentTab, setCurrentTab] = useState(
    searchParams.get("tab") || "keys"
  )
  const user = useAppSelector(selectUserDetails)
  const isSuperAdmin = useIsSuperAdmin()
  const hasApiAccess = isSuperAdmin || !!user?.org?.api_access_active

  return (
    <RequireRole allowedRoles={ALLOWED_ROLES_BY_ROUTE["api"]}>
      <div className="p-6 space-y-6">
        <PageHeader title="API Dashboard" />
        {hasApiAccess ? (
          <>
            <PillTabs
              tabs={tabs}
              currentTab={currentTab}
              onChange={setCurrentTab}
              urlParam="tab"
              className="justify-start px-0 pb-0"
            />
            {currentTab === "keys" && (
              <ApiKeysSection
                onViewUsage={(keyId: string) =>
                  setSearchParams({ tab: "usage", key: keyId })
                }
              />
            )}
            {currentTab === "usage" && (
              <ApiUsageSection initialKeyId={searchParams.get("key") || ""} />
            )}
          </>
        ) : (
          <ApiMarketingContent />
        )}
      </div>
    </RequireRole>
  )
}

export default ApiPage
